import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';

import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { CARGOCHIEF_KEYS } from '@domain/constants/app-variables';
import { environment } from '@environment/environment';
import JSEncrypt from 'jsencrypt';

@Component({
	selector: 'app-set-password',
	templateUrl: './set-password.component.html',
	styleUrls: ['./set-password.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class SetPasswordComponent implements OnInit {
	resetPasswordForm: UntypedFormGroup = null;
	isRequestInProgress: boolean = false;
	EMAIL = null;
	isFormInitialized: boolean = false;
	showCloseIcon: boolean = false;

	constructor(
		private restService: RestService,
		private urlService: UrlService,
		private _formBuilder: UntypedFormBuilder,
		private cargochief: Cargochief,
		public utilService: UtilService,
		private dialogRef: MatDialogRef<SetPasswordComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit() {
		if (
			!this.utilService.isNullOrUndefined(this.data) &&
			!this.utilService.isNullOrUndefined(this.data.showCloseIcon)
		) {
			this.showCloseIcon = this.data.showCloseIcon;
		}
		this.EMAIL = this.cargochief.getUser()?.email ?? null;
		this.initializeResetForm();
		this.isFormInitialized = true;
	}

	initializeResetForm() {
		this.resetPasswordForm = this._formBuilder.group(
			{
				password: [
					'',
					[
						Validators.required,
						Validators.minLength(8),
						Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!$%@#£€*?&]{8,}$/),
					],
				],
				confirmPassword: ['', Validators.required],
			},
			{ validator: this.checkPasswords }
		);
	}

	checkPasswords(group: UntypedFormGroup) {
		let PASSWORD = group.controls.password.value;
		let CONFIRM_PASSWORD = group.controls.confirmPassword.value;
		return PASSWORD === CONFIRM_PASSWORD ? null : { notSame: true };
	}

	resetPassword() {
		if (this.resetPasswordForm.valid && !this.utilService.isNullOrUndefined(this.EMAIL)) {
			this.isRequestInProgress = true;
			const url = this.urlService.updatePassword();
			const encrypt = new JSEncrypt();
			encrypt.setPublicKey(environment.RSA_PUBLIC_KEY);
			const rawPassword = this.resetPasswordForm.get('password').value;
			const encryptedPassword = encrypt.encrypt(rawPassword);
			if (!encryptedPassword) {
				this.utilService.showSnackbar(
					'Unable to secure your password. Please try again.',
					SNACKBAR.ERROR,
					''
				);
				this.isRequestInProgress = false;
				return;
			}
			const payload = {
				email: this.EMAIL,
				newPassword: encryptedPassword,
			};
			this.restService.POST(url, payload).subscribe(
				(result) => {
					this.utilService.showSnackbar('Password updated successfully.', SNACKBAR.SUCCESS, '');
					this.cargochief.removeItem(CARGOCHIEF_KEYS.SET_PASSWORD);
					this.closeDialog(true);
					this.isRequestInProgress = false;
				},
				(error) => {
					this.utilService.showSnackbar(
						'We were unable to process your request.',
						SNACKBAR.ERROR,
						''
					);
					this.isRequestInProgress = false;
				}
			);
		}
	}

	closeDialog(data: any = null): void {
		this.dialogRef.close(data);
	}
}
